import {
  jb_teaser_meta_css_default
} from "./chunk.SF4YKNRB.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-teaser-meta/jb-teaser-meta.ts
var JbTeaserMeta = class extends Linkable(i) {
  _renderDate() {
    if (this.date) {
      return b`<div class="date">
        <jb-icon
          iconName="material:calendar_month"
          size="20"
        ></jb-icon
        ><jb-date date=${this.date}></jb-date>
      </div>`;
    }
    return null;
  }
  _renderTime() {
    if (this.time) {
      return b`<div class="time">
        <jb-icon
          iconName="material:timer"
          size="20"
        ></jb-icon>
        ${this.time}
      </div>`;
    }
    return null;
  }
  _renderTimeZone() {
    if (this.timeZone) {
      return b`<div class="timezone">
        <jb-icon
          iconName="material:language"
          size="20"
        ></jb-icon>
        ${this.timeZone}
      </div>`;
    }
    return null;
  }
  render() {
    return b`
      <div class="info">${this._renderDate()} ${this._renderTime()} ${this._renderTimeZone()}</div>
      ${this.category && b`<jb-navigation-tags
          .activeItem=${this.category}
          .items=${[{ tag: this.category, link: this.link }]}
          class="category"
        ></jb-navigation-tags>`}
    `;
  }
};
JbTeaserMeta.styles = [reset_css_default, jb_teaser_meta_css_default];
__decorateClass([
  n()
], JbTeaserMeta.prototype, "category", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "date", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "time", 2);
__decorateClass([
  n()
], JbTeaserMeta.prototype, "timeZone", 2);
JbTeaserMeta = __decorateClass([
  customElement("jb-teaser-meta")
], JbTeaserMeta);

export {
  JbTeaserMeta
};
